import useTranslation from "@/hooks/useTranslation";
import { JournalDetailedInfo } from "@/interfaces/journal.interface";
import { Divider, Empty, Pagination, Spin } from "antd";
import React from "react";
import { Element } from "react-scroll";
import Item from "../Item";
import styles from "./styles.module.less";

const { pagination, banner } = styles;

interface IProps {
  count: number;
  page: number;
  size: number;
  term: string;
  journals: JournalDetailedInfo[];
  loading?: boolean;
  changePage: ({ page, size }: { page?: number; size?: number }) => void;
}

const Results: React.FC<IProps> = (props) => {
  const { count, page, size, journals, loading, changePage } = props;

  const { t } = useTranslation("explore");

  const handleChangePage = (page: number, size: number) => {
    changePage({ page, size });
  };

  return (
    <Element name="search-result">
      {journals?.length === 0 && (
        <Spin spinning={loading}>
          <div className={banner}>
            {t("journal.banner.start")}
            <Divider />
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          </div>
        </Spin>
      )}
      {journals.map((journal) => (
        <Item key={journal.id} journal={journal} loading={loading} />
      ))}
      {count > 0 && (
        <div className={pagination}>
          <Pagination
            total={count}
            pageSize={size}
            defaultCurrent={1}
            current={page}
            onChange={handleChangePage}
            pageSizeOptions={["10", "20", "30", "50"]}
          />
        </div>
      )}
    </Element>
  );
};

export default Results;
